import { workspaceDocSchema } from '../../../shared/sync/workspaces';
import { rxdbFromZod } from '../lib/rxdbFromZod';
import { type z } from 'zod/v4';

// The RxDB collection schema is derived from the same wire schema the
// replication adapter uses — single source of truth, the `_deleted`
// field is stripped by rxdbFromZod since RxDB manages tombstones itself.
// RxDB-specific knobs (indexes, fixed-width maxLength hints, value
// bounds) live here as plain JS objects.

export type WorkspaceDoc = Omit<z.infer<typeof workspaceDocSchema>, '_deleted'>;

export const workspaceSchema = rxdbFromZod(workspaceDocSchema, {
  indexes: ['updatedAt', 'position'],
  numericRanges: {
    position: { max: 1_000_000, min: 0, multipleOf: 1 },
  },
  primaryKey: 'id',
  stringMaxLength: { id: 26, userId: 64 },
  version: 1,
});
